/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import * as jQuery from "./jquery";
import * as bootstrap from "bootstrap";


require("./lib/career-quiz");
require("./lib/taster-quiz");
require("./lib/answers");
require("./lib/key-terms");
require("./lib/career-rating");
require("./lib/career-suggestion");
require("./lib/careers");
require("./lib/dashboard");
require("./lib/dashboard-share");
require("./lib/errors");
require("./lib/opportunities");
require("./lib/usage");
require("./lib/home");
require("./lib/rich-home");
require("./lib/taster-review");
require("./lib/kaplan-auth");
require("./lib/expertise");
require("./lib/account");
require("./lib/cvs");
require("./lib/journals");
require("./lib/journal-applications");
require("./lib/vacancies");
require("./lib/concierge");
require("./lib/topics");
require("./lib/cookie-warning");
require("./lib/purchases");
require("./lib/question-strips");
require("./lib/cover-letters");
require("./lib/tag-orderer");
require("./lib/nz");

window.setTimeout(() => {
  $(".flash-message").fadeOut();
}, 1500);
